// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.abstractTable {
  font-family: 'Proxima Nova';
  font-style: normal;
  font-weight: normal; }
  .abstractTable h2 {
    font-size: 24px;
    color: #323232;
    font-family: 'Proxima Nova';
    font-weight: 600;
    margin-bottom: 0;
    margin-right: 10px; }
  .abstractTable .justify-center {
    justify-content: center; }
  .abstractTable .justify-sb {
    justify-content: space-between; }
  .abstractTable .align-center {
    align-items: center; }
  .abstractTable .chat-icon span {
    color: #637f92;
    font-size: 16px;
    line-height: 19px;
    margin-left: 4px; }
  .abstractTable .state-date {
    margin-top: 14px;
    margin-bottom: 12px;
    align-items: baseline; }
    .abstractTable .state-date .date {
      color: #323232;
      font-size: 16px;
      line-height: 19px; }
    .abstractTable .state-date .state {
      color: #586f80;
      background: #f0f4f7;
      border-radius: 4px;
      padding: 4px 8px;
      margin-right: 13px;
      font-weight: 600; }
  .abstractTable .member-slot {
    margin-bottom: 24px;
    color: #323232;
    font-size: 16px; }
  .abstractTable .delete-batch {
    display: flex;
    flex-direction: column;
    align-items: flex-end; }
    .abstractTable .delete-batch .delete-icon {
      margin-top: 30px; }
      .abstractTable .delete-batch .delete-icon span {
        margin-left: 8px;
        font-size: 16px;
        color: #637f92;
        font-weight: 600; }

.draggable-table {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; }
  .draggable-table thead tr {
    background: #f8fafb; }
  .draggable-table .serialNo {
    width: 58px; }
  .draggable-table thead,
  .draggable-table tbody {
    width: 100%;
    display: flex;
    flex-direction: column; }
    .draggable-table thead .tableRow,
    .draggable-table tbody .tableRow {
      cursor: grabbing; }
    .draggable-table thead tr,
    .draggable-table tbody tr {
      display: flex;
      justify-content: space-around;
      width: 100%;
      min-height: 65px; }
      .draggable-table thead tr th,
      .draggable-table thead tr td,
      .draggable-table tbody tr th,
      .draggable-table tbody tr td {
        padding: 16px;
        border: 0.25px solid #e1e7ec;
        width: 25%;
        font-size: 16px;
        text-align: left;
        vertical-align: middle; }
      .draggable-table thead tr th,
      .draggable-table tbody tr th {
        color: #637f92;
        font-weight: 600; }
      .draggable-table thead tr tr,
      .draggable-table tbody tr tr {
        font-weight: normal;
        color: #323232; }
  .draggable-table .table-action {
    margin-left: 10px;
    cursor: pointer; }
`, "",{"version":3,"sources":["webpack://./src/components/TableInput/DragAndDropTable/styles.scss"],"names":[],"mappings":"AAAA;EACI,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB,EAAA;EAHvB;IAMQ,eAAe;IACf,cAAc;IACd,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB,EAAA;EAX1B;IAeQ,uBAAuB,EAAA;EAf/B;IAmBQ,8BAA8B,EAAA;EAnBtC;IAuBQ,mBAAmB,EAAA;EAvB3B;IA4BY,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB,EAAA;EA/B5B;IAoCQ,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB,EAAA;IAtC7B;MAyCY,cAAc;MACd,eAAe;MACf,iBAAiB,EAAA;IA3C7B;MA+CY,cAAc;MACd,mBAAmB;MACnB,kBAAkB;MAClB,gBAAgB;MAChB,kBAAkB;MAClB,gBAAgB,EAAA;EApD5B;IAyDQ,mBAAmB;IACnB,cAAc;IACd,eAAe,EAAA;EA3DvB;IA+DQ,aAAa;IACb,sBAAsB;IACtB,qBAAqB,EAAA;IAjE7B;MAoEY,gBAAgB,EAAA;MApE5B;QAuEgB,gBAAgB;QAChB,eAAe;QACf,cAAc;QACd,gBAAgB,EAAA;;AAQhC;EACI,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB,EAAA;EAJ3B;IAQY,mBAAmB,EAAA;EAR/B;IAYQ,WAAW,EAAA;EAZnB;;IAiBQ,WAAW;IACX,aAAa;IACb,sBAAsB,EAAA;IAnB9B;;MAsBY,gBAAgB,EAAA;IAtB5B;;MA0BY,aAAa;MACb,6BAA6B;MAC7B,WAAW;MACX,gBAAgB,EAAA;MA7B5B;;;;QAiCgB,aAAa;QACb,4BAA4B;QAC5B,UAAU;QACV,eAAe;QACf,gBAAgB;QAChB,sBAAsB,EAAA;MAtCtC;;QA0CgB,cAAc;QACd,gBAAgB,EAAA;MA3ChC;;QA+CgB,mBAAmB;QACnB,cAAc,EAAA;EAhD9B;IAsDQ,iBAAiB;IACjB,eAAe,EAAA","sourcesContent":[".abstractTable {\n    font-family: 'Proxima Nova';\n    font-style: normal;\n    font-weight: normal;\n\n    h2 {\n        font-size: 24px;\n        color: #323232;\n        font-family: 'Proxima Nova';\n        font-weight: 600;\n        margin-bottom: 0;\n        margin-right: 10px;\n    }\n\n    .justify-center {\n        justify-content: center;\n    }\n\n    .justify-sb {\n        justify-content: space-between;\n    }\n\n    .align-center {\n        align-items: center;\n    }\n\n    .chat-icon {\n        span {\n            color: #637f92;\n            font-size: 16px;\n            line-height: 19px;\n            margin-left: 4px;\n        }\n    }\n\n    .state-date {\n        margin-top: 14px;\n        margin-bottom: 12px;\n        align-items: baseline;\n\n        .date {\n            color: #323232;\n            font-size: 16px;\n            line-height: 19px;\n        }\n\n        .state {\n            color: #586f80;\n            background: #f0f4f7;\n            border-radius: 4px;\n            padding: 4px 8px;\n            margin-right: 13px;\n            font-weight: 600;\n        }\n    }\n\n    .member-slot {\n        margin-bottom: 24px;\n        color: #323232;\n        font-size: 16px;\n    }\n\n    .delete-batch {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n\n        .delete-icon {\n            margin-top: 30px;\n\n            span {\n                margin-left: 8px;\n                font-size: 16px;\n                color: #637f92;\n                font-weight: 600;\n            }\n        }\n    }\n}\n\n// for table\n\n.draggable-table {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    thead {\n        tr {\n            background: #f8fafb;\n        }\n    }\n    .serialNo {\n        width: 58px;\n    }\n\n    thead,\n    tbody {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n\n        .tableRow {\n            cursor: grabbing;\n        }\n\n        tr {\n            display: flex;\n            justify-content: space-around;\n            width: 100%;\n            min-height: 65px;\n\n            th,\n            td {\n                padding: 16px;\n                border: 0.25px solid #e1e7ec;\n                width: 25%;\n                font-size: 16px;\n                text-align: left;\n                vertical-align: middle;\n            }\n\n            th {\n                color: #637f92;\n                font-weight: 600;\n            }\n\n            tr {\n                font-weight: normal;\n                color: #323232;\n            }\n        }\n    }\n\n    .table-action {\n        margin-left: 10px;\n        cursor: pointer;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
